// Environment variable types for better TypeScript support
export interface ViteEnvironment {
  VITE_API_URL?: string;
  VITE_APP_TITLE?: string;
  VITE_APP_VERSION?: string;
  VITE_DEBUG?: string;
  [key: string]: string | undefined;
}

// Type-safe environment access
export const getEnvVar = (key: keyof ViteEnvironment): string | undefined => {
  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
  return env ? env[key] : undefined;
};

// Environment configuration with defaults
export const ENV_CONFIG = {
  API_URL: getEnvVar('VITE_API_URL') || 'https://myfood.work/api',
  API_TIMEOUT: 10000,
  APP_TITLE: getEnvVar('VITE_APP_TITLE') || 'MyFood',
  APP_VERSION: getEnvVar('VITE_APP_VERSION') || '1.0.0',
  DEBUG: getEnvVar('VITE_DEBUG') === 'true',
} as const;

// Type for environment configuration
export type EnvConfig = typeof ENV_CONFIG;
